export default "__VITE_ASSET__0NQ0AYOX__"